import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../../layout/layout.component';
import { PagerService } from '../../../common/pagerService';
import 'rxjs/add/operator/map'
import { PageEvent } from '@angular/material';
import { SampleSearchFields } from '../../../common/viewModels/Analysis/SampleModel';
import { CustomerModel } from '../../../common/viewModels/Admin/CustomerModel';
import { FerroGraphyImages } from '../../../common/viewModels/Analysis/SampleModel';
import { SampleStatusTypes } from '../../../common/enumcontainer.enum';
import { JobCardDDLModel, SampleStatusDDLModel, SampleModel } from '../../../common/viewModels/Analysis/SampleModel';
import { SpIdSearchFields } from '../../../common/viewModels/GlobalRegistry/SampPointModel';
import { FormatService } from '../../../common/formatService';
import { AmplifyService } from '../../../common/amplify-service';
import { SampleTypesEnum } from '../../../common/enumcontainer.enum';
import { ApproveSampleResults } from '../approvesampleresults/approvesampleresults.component';
declare var $: any;

@Component({
  selector: 'samplestatus',
  templateUrl: './samplestatus.component.html',
  styleUrls: ['./samplestatus.component.scss']
})
export class SampleStatus implements OnInit {
  sampleSearchForm: FormGroup;
  fileUploadForm: FormGroup;
  ferroFileUploadForm: FormGroup;
  searchFields: SampleSearchFields = new SampleSearchFields();
  id: number;
  isNoRecords: boolean = true;
  pager: any = {};
  pagedItems: any[];
  length: number = 0;
  ferroFiles: FerroGraphyImages[];
  ferroImgs: any[];
  labs: any;
  lstJobCards: JobCardDDLModel[];
  lstSampleStatus: SampleStatusDDLModel[];
  lstSpIds: SpIdSearchFields[];
  sampleDto: SampleModel;
  samples: SampleModel = new SampleModel();
  isShow: boolean = false;
  File: any;
  name: any;
  ImgBinary: any;
  extension: any;
  isShowbtnDownload: boolean = false;
  
  customers: CustomerModel[];
  customersTemp: CustomerModel[];
  sample: SampleModel = new SampleModel();
  mainComponent: any;
  imageFile: FormData = new FormData();
  excelFile: FormData = new FormData();
  finalPath: any;
  ferroFileName: any;
  fileErrorMsg: boolean = false;
  hasImageFile: boolean = false;
  baseUrl: string;
  lstSampleTypes: any[];
  sampleTypesEnum: any;
  pageSize: number = 10;
  isShowSelectOption: boolean = true;

  constructor(public _router: Router, private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute, private _pagerService: PagerService,
    private _mApp: MainAppComponent, private _toastrService: ToastrService, private _formatService: FormatService,
    private _amplifyService: AmplifyService) {
    this.mainComponent = _mApp;
  }

  ngOnInit() {
    this.sampleTypesEnum = SampleTypesEnum;
    this.baseUrl = this._appUrl.baseUrl;
    this.sample.SampleStatusTypeId = SampleStatusTypes.ResultsPublished
    this.pager.pageIndex = 0;
    this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
    this.CreateSearchForm();
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
    this.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
    this.pager.pageSize = this.pageSize;
    if (curUserDetails && curUserDetails.LabIds && curUserDetails.UserTypeId == 2) {
        this.sampleSearchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
    }
    if (curUserDetails && curUserDetails.DefaultCompanyId) {
        this.sampleSearchForm.controls['CustomerId'].setValue(parseInt(curUserDetails.DefaultCompanyId));
    }
    if(curUserDetails && curUserDetails.RoleId == 9 && curUserDetails.UserTypeId == 3){
      this.isShowSelectOption = false;
      this.BindSpId(this.sampleSearchForm.get('CustomerId').value);
    }
    this.ConstructSearchData();
    this.CreateFileUploadForms();
    this.GetJobCradsForDDL();
    this.GetSampleStatusForDDL();
    this.GetLabs();
    this.GetCustomers();
    //this.BindStaticSearchData();
    this.GetSampleTypes();
    this.GetDataFromAmpliy();
    this.setPage(this.pager);
    this.ClearDataInAmplify();
  }

  CreateSearchForm() {
    this.sampleSearchForm = this._formBuilder.group({
      SampleNo: [''],
      SpId: [''],
      CustomerId: [''],
      LabIds: [''],
      JobCardNumber: [''],
      ReceivedFrom: [null],
      ReceivedTo: [null],
      SampleStatusTypeId: [''],
      SampleTypeId: ['']
    });
  }

  CreateFileUploadForms() {
    this.fileUploadForm = this._formBuilder.group({
      SampleId: [0],
      'File': this._formBuilder.group({
        ImgBinary: [''],
        FileName: [''],
        FileExtension: [''],
      }),
    });
    this.ferroFileUploadForm = this._formBuilder.group({
      ImageId: [''],
      SampleId: [0],
      FileName: [''],
      Path: [''],
      Description: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(500)])]
    });
  }

  setPage(page: any) {
    this.pager.pageSize = page.pageSize;
    this.pager.pageIndex = page.pageIndex;
    this.GetSampleList(this.pager);
  }

  filterCustomer(val) {

    this.customers = this.customersTemp.filter(m => m.Name.toLowerCase().indexOf(val.toLowerCase()) === 0);
  }
  displayFn(customer) {
    return customer ? customer.Name : customer;
  }

  BindStaticSearchData() {
    this.searchFields.PageNo = 0;
    this.searchFields.PageSize = this._pagerService.globalPageSize;
  }

  GetJobCradsForDDL() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetJobcradsForDDL)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          this.lstJobCards = data.json().Result;
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  GetLabs() {
    this._http.get(this._appUrl.GetLabsMinInfoList)
      .subscribe(
        data => {
          if(this._mApp.userTypeId == 2) {
            let lstLabs = data.json().Result;
            if (this._mApp.currentUserLabIds && lstLabs)
              lstLabs = lstLabs.filter(m => this._mApp.currentUserLabIds.includes(m.LabId));
            this.labs = lstLabs;
          }
          else {
            this.labs = data.json().Result;
          }
        },
        error => {
          this._toastrService.error(error.json())
        }
      )
  }

  GetSampleStatusForDDL() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetSampleStatusForDDL)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          this.lstSampleStatus = data.json().Result;
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  GetCustomers() {
    this._http.get(this._appUrl.GetCustomersMinInfoList)
      .subscribe(
        data => {
          this.customers = data.json().Result;
          this.customersTemp = data.json().Result;
        },
        error => {
          this._toastrService.error(error.json().Result, '')
        }
      )
  }

  GetSampleById(id: number) {

    this.id = id;
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetSampleDetail + this.id)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          if (data.json() != null) {
            this.isShow = true;
            this.sampleDto = (data.json().Result);
          }
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  GetSampleList(page: any) {
    this._mApp.ShowLoader();
    this.searchFields.PageNo = page.pageIndex;
    this.searchFields.PageSize = page.pageSize;
    this._http.post(this._appUrl.GetSamplesList, this.searchFields)
      .subscribe(
        res => {
          this._mApp.HideLoader();
          var data = res.json();
          this.length = data.PageResult.TotalRecords;
          this.pagedItems = data.Result;
          this.isNoRecords = !(data.Result.length > 0);
          //code for custom paginator. comment this for using mat paginator
          // this.pager = this._pagerService.getPager(data.PageResult.TotalRecords, this.pager.pageIndex + 1, this.pager.pageSize)
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  onSubmit() {
    this.pager.pageIndex = 0;
    this.ConstructSearchData();
    this.setPage(this.pager);
  }

  OnReset() {
    this.sampleSearchForm.reset();
    this.searchFields.SampleNo = "";
    this.searchFields.SpId = 0;
    // this.searchFields.LabIds = this._mApp.currentUserLabIds ? this._mApp.currentUserLabIds : [];
    this.searchFields.CustomerId = this._mApp.currentUserDefaultCompanyId ? parseInt(this._mApp.currentUserDefaultCompanyId) : 0;
    this.searchFields.JobCardNumber = '';
    this.searchFields.ReceivedDateFrom = '';
    this.searchFields.ReceivedDateTo = '';
    this.searchFields.SampleStatusTypeId = 0;
    this.searchFields.SampleTypeId = 0;
    this.searchFields.LabIds = [];
    this.pager.pageSize = this._mApp.pageSize;
    this.pager.pageIndex = 0;
    this.GetJobCradsForDDL();
    this.GetSampleStatusForDDL();
    this.GetCustomers();
    // this.sampleSearchForm.controls['LabIds'].setValue(this._mApp.currentUserLabIds ? this._mApp.currentUserLabIds : []);
    this.sampleSearchForm.controls['CustomerId'].setValue(this._mApp.currentUserDefaultCompanyId ? parseInt(this._mApp.currentUserDefaultCompanyId) : 0);
    this.BindSpId(this._mApp.currentUserDefaultCompanyId ? parseInt(this._mApp.currentUserDefaultCompanyId) : 0);
    this.lstSpIds = null;
    this.setPage(this.pager);
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
    if (this._mApp.userTypeId == 2) {
      this.sampleSearchForm.controls['LabIds'].setValue(JSON.parse(curUserDetails.LabIds));
    }
    if(curUserDetails && curUserDetails.RoleId == 9 && curUserDetails.UserTypeId == 3){
      this.BindSpId(this.sampleSearchForm.get('CustomerId').value);
    }
  }

  ConstructSearchData() {
    let searchDto = this.sampleSearchForm.value;
    this.searchFields.SpId = searchDto.SpId;
    this.searchFields.LabIds = searchDto.LabIds;
    this.searchFields.CustomerId = searchDto.CustomerId;
    this.searchFields.JobCardNumber = searchDto.JobCardNumber;
    this.searchFields.ReceivedDateFrom = this._formatService.formatDate(searchDto.ReceivedFrom);
    this.searchFields.ReceivedDateTo = this._formatService.formatDate(searchDto.ReceivedTo);
    this.searchFields.SampleStatusTypeId = searchDto.SampleStatusTypeId;
    this.searchFields.SampleTypeId = searchDto.SampleTypeId;
  }

  DeleteSample(id: any) {
    this.id = id;
  }

  DeleteSampleById(id: number) {
    this.SaveDataInAmplify();
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.DeleteSample + id)
      .subscribe(
        res => {
          this._mApp.HideLoader();
          this.GetDataFromAmpliy();
          this.setPage(this.pager);
          this._toastrService.success(res.json().Result, '');

        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  ShowAnalysisProgress(lstActions) {
    for (let item of lstActions) {
      if (item.SampleWfActionId == 2)
        return true;
    }
    return false;
  }

  NavigateEditToApprove(lstActions) {
    for (let item of lstActions) {
      if (item.SampleWfActionId == 5)
        return true;
    }
    return false;
  }

  ShowAddResults(lstActions) {
    for (let item of lstActions) {
      if (item.SampleWfActionId == 3)
        return true;
    }
    return false;
  }

  ShowApproveResults(lstActions) {
    for (let item of lstActions) {
      if (item.SampleWfActionId == 4)
        return true;
    }
    return false;
  }

  ShowGenerateReport(lstActions) {
    for (let item of lstActions) {
      if (item.SampleWfActionId == 5)
        return true;
    }
    return false;
  }

  ShowDownloadReport(lstActions) {
    for (let item of lstActions) {
      if (item.SampleWfActionId == 6)
        return true;
    }
    return false;
  }

  ShowRevertToApproved(lstActions) {
    for (let item of lstActions) {
      if (item.SampleWfActionId == 7)
        return true;
    }
    return false;
  }

  RevertToApproved(id) {
    this.SaveDataInAmplify();
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.RevertToApproved + id)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          this._toastrService.success(data.json().Result);
          this.GetDataFromAmpliy();
          this.setPage(this.pager);
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      )
  }

  MarkSampleInProgress(id) {
    this.SaveDataInAmplify();
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.MarkSampleInProgress + id)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          this._toastrService.success(data.json().Result, '');
          this.GetDataFromAmpliy();
          this.setPage(this.pager);
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      )
  }

  fileChange(evt) {
    var files = evt.target.files;
    var file = files[0];
    this.name = file.name.split(".");
    var filesize = file.size;
    if (files && file) {
      var ext = file.name.split(".").pop();
      this.extension = ext;
      if (ext == "pdf") {
        if (filesize < 2148576) {
          $('#fileUpError').hide();
          $('#fileSizeError').hide();
          var myReader: FileReader = new FileReader();
          myReader.onload = (e) => {
            this.File = myReader.result;
          }
          myReader.readAsDataURL(file);
        }
        else {
          $('#fileSizeError').show();
        }
      }
      else {
        $('#fileUpError').show();
      }
    }
  }

  AddSampleReport() {
    if (this.File != null) {
      this.SaveDataInAmplify();
      this._mApp.ShowLoader();
      this.ImgBinary = this.File;
      let fileUpDetails = this.fileUploadForm.value;
      fileUpDetails.SampleId = this.id;
      fileUpDetails.File.ImgBinary = this.ImgBinary;
      fileUpDetails.File.FileName = this.name[0];
      fileUpDetails.File.FileExtension = this.extension;
      this._http.post(this._appUrl.AddSampleReport, fileUpDetails)
        .subscribe(
          res => {
            this._mApp.HideLoader();
            $('#fileUploadModel').toggle('modal');
            $('#fileUpload').val('');
            this.File = null;
            this.isShowbtnDownload = true;
            this._toastrService.success(res.json().Result, '');
            this.GetDataFromAmpliy();
            this.setPage(this.pager);
          },
          error => {
            this._mApp.HideLoader();
            this._toastrService.error(error.json().Result, '');
          }
        );
    }
    else
      this._toastrService.error("Please upload pdf file to continue", '');
  }

  GenerateReport(sampleId: number, SampleTypeId: number) {
    this.SaveDataInAmplify();
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GenerateReport + sampleId + "&sampleTypeId=" + SampleTypeId)
      .subscribe(
        res => {
          this._mApp.HideLoader();
          this._toastrService.success(res.json().Result);
          this.GetDataFromAmpliy();
          this.setPage(this.pager);
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  GenerateReportTemp(sampleId: number, SampleTypeId: number) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.DownLoadSampleReport + sampleId + "&viewReport=" + false)
      .subscribe(
        res => {
          this._mApp.HideLoader();
          var data = res.json().Result;
          window.open(res.json().Result, '_blank');
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }


  DownloadFile(id) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetSampleReportById + id)
      .subscribe(
        res => {
          this._mApp.HideLoader();
          var data = res.json().Result;
          this._mApp.DownloadFile(data);
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  RemoveUploadValidations() {
    $('#fileUpload').val("");
    $('#fileUpError').hide();
    $('#fileSizeError').hide();
    this.File = null;
  }

  BindSpId(custId) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.PopulateSpIdValuesByCustomerId + custId)
      .subscribe(
        data => {
          if (data.json().Result != null) {
            this.lstSpIds = data.json().Result;
          }
          this._mApp.HideLoader();
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result);
        }
      )
  }


  ClearImageValidations() {
    this.fileErrorMsg = false;
    $('#fileUploadImg').val('');
    this.ferroFileUploadForm.reset();
    this.imageFile = new FormData();
    this.hasImageFile = false;
  }

  RemoveHtmlFromDiv() {
    $("#dvAttchHtml").html("");
  }

  ViewReport(sampleId: number) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.DownLoadSampleReport + sampleId + "&viewReport=" + true)
      .subscribe(
        res => {

          this._mApp.HideLoader();
          $("#dvAttchHtml").append(res.json().Result);
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
      );
  }

  uploadImage(event: any) {
    this.imageFile = new FormData();
    //this.ferroFiles = [];
    var element = ((window.event) ? (event.srcElement) : (event.currentTarget));
    var srcElement = event.srcElement || event.target;
    var files = srcElement.files;
    var size = files[0].size;
    let formData = new FormData();
    this.hasImageFile = true;

    let ferroReportImages = this.ferroFiles.filter(m => m.ImageId > 0);
    if (!(ferroReportImages.length + files.length > 4)) {
      for (let i = 0; i < files.length; i++) {
        var ext = files[i].name.split('.').reverse()[0].toLowerCase();
        if (ext == "jpeg" || ext == "png" || ext == "gif" || ext == "jpg" || ext == "bmp") {
          this.imageFile.append("uploads[]", files[i], files[i].name);
          var fileName = files[i].name.split('.').slice(0, -1).join('.');

        }
        else {
          this._toastrService.error("Please upload image files only");
          $("#fileUploadImg").val('');
          break;
        }
      }
      this.UploadInFolder(this.imageFile);
    }
    else {
      this._toastrService.error("You cannot upload more than 4 images for a sample.");
      $("#fileUploadImg").val('');
    }
  }

  UploadInFolder(imageFile) {
    this._mApp.ShowLoader();
    this._http.postUpload(this._appUrl.UploadFile, imageFile)
      .subscribe(
        data => {

          this._mApp.HideLoader();
          this.ferroFiles = this.ferroFiles;
          let respo = data.json().Result;
          if (this.ferroFiles.length >= 4) {
            let index = this.ferroFiles.findIndex(m => m.ImageId == 0);
            if (index != undefined && index >= 0 && index != null)
              this.ferroFiles.splice(index, 1);
          }
          for (let item of respo) {
            this.ferroFiles.push({
              ImageId: item.ImageId,
              SampleId: item.SampleId,
              Path: item.Path,
              FileName: item.FileName,
              Description: item.Description
            });
          }
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result);
        }
      );
  }

  UploadSubmit(sampleId) {
    this._mApp.ShowLoader();
    for (let item of this.ferroFiles) {
      item.SampleId = sampleId;
      item.Description = this.ferroFileUploadForm.controls['Description'].value;
    }
    this._http.postUpload(this._appUrl.SaveFerrographyImages, this.ferroFiles)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          this._toastrService.success(data.json().Result);
          $('#uploadferrographyimgsModel').modal('toggle');
          this.ClearImageValidations();
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result);
        }
      );
  }

  GetFerrographyImagesbySampleId(sampleId) {

    this.id = sampleId;
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetFerrographyImagesbySampleId + sampleId)
      .subscribe(
        data => {
          this._mApp.HideLoader();
          if (data.json().Result != null) {
            //this.ferroImgs = data.json().Result;
            this.ferroFiles = data.json().Result;
            this.ferroFileUploadForm.controls['Description'].setValue(this.ferroFiles[0].Description);
          }
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result);
        }
      )
  }

  DeleteFerrographyImage(imageId) {

    var result = confirm("Are you sure to delete?")
    if (result == true) {
      this.ferroFiles = this.ferroFiles.filter(function (item) { item.ImageId != imageId });
      this._mApp.ShowLoader();
      this._http.get(this._appUrl.DeleteFerrographyImage + imageId)
        .subscribe(
          data => {
            this._mApp.HideLoader();
            this._toastrService.success(data.json().Result);
            this.GetFerrographyImagesbySampleId(this.id);
          },
          error => {
            this._mApp.HideLoader();
            this._toastrService.error(error.json().Result);
          }
        )
    }
  }

  GetSampleTypes() {
    this._http.get(this._appUrl.GetMinInfoSampleTypes)
      .subscribe(
        data => {
          if (data.json().Result != null)
            this.lstSampleTypes = data.json().Result;
        },
        error => {
          this._toastrService.error(error.json().Result);
        }
      )
  }

  DownloadNablExcel(sampleId) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.DownloadNablExcel + sampleId)
      .subscribe(
        data => {

          this._mApp.HideLoader();
          var res = data.json().Result;
          if (res != "" && res != null && res != undefined) {
            window.open(res, '_blank');
          }
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result);
        }
      )
  }

  SaveDataInAmplify() {
    this._amplifyService.SetStorage('samplesList', this.sampleSearchForm.value);
    this._amplifyService.SetStorage('samplesList_PageNo', this.pager.pageIndex);
    this._amplifyService.SetStorage('samplesList_PageSize', this.pager.pageSize);
  }
  GetDataFromAmpliy() {
    let storedData = this._amplifyService.GetStorage('samplesList');
    if (storedData != undefined && storedData != null) {
      if (storedData.CustomerId > 0)
        this.BindSpId(storedData.CustomerId);
      this.sampleSearchForm.setValue(storedData);
      this.ConstructSearchData();
    }
    // let savedPageSize = this._amplifyService.GetStorage('samplesList_PageSize');
    // this.pager.pageSize = savedPageSize > 0 ? savedPageSize : this._pagerService.pageSize;
    let pageIndex = this._amplifyService.GetStorage('samplesList_PageNo');
    if (pageIndex != null && pageIndex != '' && pageIndex != undefined)
      this.pager.pageIndex = pageIndex;
    else
      this.pager.pageIndex = 0;
  }

  ClearDataInAmplify() {
    this._amplifyService.ClearStorage('samplesList');
    this._amplifyService.ClearStorage('samplesList_PageNo');
    this._amplifyService.ClearStorage('samplesList_PageSize');
  }

}
